module.exports = __webpack_public_path__ + "img/teach.bb1a1e63.png";